var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "invited"
  }, [_c('TipsDailog', {
    staticClass: "setJoinBox",
    attrs: {
      "info": _vm.inviteInfo,
      "width": "560px"
    },
    on: {
      "save": _vm.setJoinWay,
      "open": _vm.getHadInviteUser
    }
  }, [_c('div', {
    staticClass: "controlInvite"
  }, [_c('svg', {
    staticClass: "m_r_20 icon-permission1",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-permission1"
    }
  })]), _c('el-select', {
    attrs: {
      "popper-class": "modelSelect",
      "placeholder": "please select model"
    },
    on: {
      "change": _vm.showHadInvite
    },
    model: {
      value: _vm.selectModule,
      callback: function ($$v) {
        _vm.selectModule = $$v;
      },
      expression: "selectModule"
    }
  }, _vm._l(_vm.joinModel, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm._f("showJoinModel")(item.value),
        "value": item.value
      }
    });
  }), 1), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.urlAddress,
      expression: "urlAddress",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    staticClass: "copy"
  }, [_vm._v(" " + _vm._s(_vm.$t('invite.copyLink')) + " ")]), _c('el-divider', {
    staticStyle: {
      "margin-left": "12px",
      "margin-right": "12px"
    },
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    staticClass: "qrCode",
    attrs: {
      "effect": "dark",
      "popper-class": "qrCodeBox",
      "content": "Top Left 提示文字",
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    staticClass: "qrCodeImg",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _c('div', {
    staticClass: "qrCodeText"
  }, [_vm._v(_vm._s(_vm.$t('common.qrCodeText')))])]), _c('div', {
    attrs: {
      "id": "qrCode"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-Vector1"
  })])])], 1), _vm.selectModule === 1 || _vm.selectModule === 3 ? _c('el-divider', {
    staticClass: "inviteSlider"
  }) : _vm._e(), _vm.selectModule === 1 ? _c('div', {
    staticClass: "inviteBox"
  }, [_c('div', {
    staticClass: "userListBox"
  }, [_c('p', {
    staticClass: "moduleTitle"
  }, [_vm._v(_vm._s(_vm.$t('invite.shareTo')))]), _c('div', {
    staticClass: "moduleContent"
  }, [_c('svg', {
    staticClass: "m_r_20 icon-share3",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-share3"
    }
  })]), _c('el-input', {
    ref: "emailInput",
    class: {
      redBorder: _vm.showErrorEmailText
    },
    attrs: {
      "placeholder": _vm.$t('invite.invitePlaceholder'),
      "clearable": ""
    },
    on: {
      "input": _vm.checkInputText
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addInviteList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchName,
      callback: function ($$v) {
        _vm.searchName = $$v;
      },
      expression: "searchName"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.addInviteList
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1), _vm.showErrorEmailText ? _c('p', {
    staticClass: "redColor emailWarn"
  }, [_vm._v("* " + _vm._s(_vm.$t('invite.emailCorrectly')))]) : _vm._e()]), _c('div', {
    staticClass: "hadInviteList scrollbar gray"
  }, [_vm._l(_vm.willInviteList, function (user, index) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.removeInvite(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  }), _vm.willInviteList.length ? _c('el-divider') : _vm._e(), _vm._l(_vm.hadInviteList, function (user) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.deleteInvite(user.name);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  })], 2)]) : _vm._e(), _vm.selectModule === 3 ? _c('div', {
    staticClass: "passCodeBox"
  }, [_c('div', {
    staticClass: "moduleTitle"
  }, [_vm._v(_vm._s(_vm.$t('invite.passCode')))]), _c('div', {
    staticClass: "passContent",
    class: {
      noMarginRIght: _vm.editPass
    }
  }, [_c('svg', {
    staticClass: "m_r_20 icon-passcode",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-passcode"
    }
  })]), _c('el-input', {
    class: {
      onFocus: _vm.editPass,
      onFocusError: _vm.showErrorPassCode
    },
    attrs: {
      "maxlength": 6
    },
    on: {
      "input": _vm.judgePassCode
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.modifyPassWord('byEnter');
      }
    },
    model: {
      value: _vm.passCodeVal,
      callback: function ($$v) {
        _vm.passCodeVal = $$v;
      },
      expression: "passCodeVal"
    }
  }), _vm.editPass ? _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.passCodeVal,
      expression: "passCodeVal",
      arg: "copy"
    }],
    staticClass: "copy",
    class: {
      saves: _vm.editPass
    },
    on: {
      "click": function ($event) {
        return _vm.modifyPassWord('byEnter');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.saveInvite')) + " ")]) : _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.passCodeVal,
      expression: "passCodeVal",
      arg: "copy"
    }],
    staticClass: "copy",
    class: {
      saves: _vm.editPass
    },
    on: {
      "click": _vm.onCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.copyPassCode')) + " ")])], 1), _vm.showErrorPassCode ? _c('div', {
    staticClass: "redColor passwordText"
  }, [_vm._v(_vm._s(_vm.$t('invite.passWordText')))]) : _vm._e()]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };